  // src/api/salesOrderApi.js
  import axiosInstance from "./axiosInstance";

  // ✅ Fetch orders by state, status, date range
  export const fetchorders = async (state, status, startDate, endDate) => {
    try {
      const payload = {
        state: state || "",
        status: status || "",
        start_date: startDate || "",
        end_date: endDate || "",
      };
      const res = await axiosInstance.post("/order/get_orders_by_state", payload);
      const raw = res.data?.data;
      return Array.isArray(raw) ? raw : [];
    } catch (error) {
      console.error("Error fetching orders:", error);
      return [];
    }
  };

  export const upsertOrders = async (data) => {
    try {
      const res = await axiosInstance.post("/order/update_order_status", data);
      return res.data;
    } catch (error) {
      console.error("Error in upsertOrders:", error.response || error);
      throw error;
    }
  };
